import React from 'react'
import { GridContainer, GridItem, Image, Item, List } from './Infographics.styles'

/**
 * The FichaSuppliersAmount component.
 */
const FichaSuppliersAmount = () => (
  <GridContainer padding="0 0 8px">
    <GridItem sm={6} xs={12}>
      <Image alt="Imagen ayuda" src="/assets/images/accordion-examples/Ejemplo-DetalleProveedores.svg" />
    </GridItem>
    <GridItem sm={6} xs={12}>
      <List>
        <Item>Link para volver a la tabla de proveedores del año seleccionado.</Item>
        <Item>Eje correspondiente a los montos transados en millones de pesos.</Item>
        <Item>
          La burbuja representa la cantidad de montos transados y número de órdenes de compra entre el proveedor y el
          organismo comprador. Mientras más arriba la burbuja, mayor el monto y mientras más grande el tamaño, mayor el
          número de órdenes de compra.
        </Item>
        <Item>Información del proveedor.</Item>
        <Item>Link a la ficha del proveedor en Mercado Público.</Item>
        <Item>Eje correspondiente a todos los meses del año.</Item>
      </List>
    </GridItem>
  </GridContainer>
)

export default FichaSuppliersAmount
